import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvService } from '../env.service';
import { Observable, of } from 'rxjs';
import { AuthService } from '../auth.service';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import * as reservationsData from '../reservations/reservationsData.json';
@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  apiUrl = '';
  token;
  constructor(private http: HttpClient,
              private envService: EnvService, private authService: AuthService, private storage: NativeStorage) {
        this.apiUrl = envService.API_URL;
  }
  getAvailable(params): Observable<any> {
    // return of(reservationsData['default']);
    return this.http.get(this.apiUrl + 'reservations/available', { withCredentials: true });
  }
  reserve(session_id, cancel_reservation_id) {

    return this.http.post(this.apiUrl + 'reservation/' + cancel_reservation_id, {
      session_id
    }, { withCredentials: true});
  }
}
